



















































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import {
  Cell,
  Field,
  Button,
  Checkbox,
  CheckboxGroup,
  Radio,
  Toast,
  RadioGroup,
  Dialog
} from "vant";
import CustomSelect from "../components/CustomSelect.vue";
import { jumpLink } from "@/utils/hybirdMethods";
import { getBrowser } from "@/utils/browser";
const browser = getBrowser();

const createAccountModule = namespace("createAccount");

@Component({
  name: "SurveyPageOne",
  components: {
    [Cell.name]: Cell,
    [Field.name]: Field,
    customSelect: CustomSelect,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup
  }
})
export default class SurveyPageOne extends Vue {
  @createAccountModule.Mutation("SAVE_EXAMINE_LIST") saveExamineList: any;

  showCheckBoxInput = false;
  form = {
    education: ""
  };

  investTarget: any = [];

  // derivative: any = [];
  derivative: any = {
    t0: {
      value: "",
      children: {
        t0: [],
        t1: [],
        t2: ""
      }
    }
  };
  isAgree = false;
  isWhitelistUsers = false;

  get investTargetDisabled() {
    if (this.investTarget[0].value.length) {
      return this.investTarget[0].value.some(key => {
        const option = this.investTarget[0].options[key - 1];
        if (option.isChecked && !option.inputValue) {
          return true;
        } else {
          return false;
        }
      });
    } else {
      return true;
    }
  }

  get derivativeDisabled() {
    const { t0 } = this.derivative;
    
    if (t0.value === "") return true;
    return !(
      (t0.children.t0 && t0.children.t0.length > 0) ||
      (t0.children.t1 && t0.children.t1.length > 0) ||
      t0.children.t2 !== ""
    );
    // return false;
  }

  get allowOpenAccount() {
    const { t0 } = this.derivative;
    if (t0.value === 0) {
      return !(
        t0.children.t0 &&
        t0.children.t0.length == 0 &&
        t0.children.t1 &&
        t0.children.t1.length == 0 &&
        t0.children.t2 !== 0
      );
    }
    return true;
    // else {
    //   return false;
    // }
  }
  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get isSubmitDisabled() {
    const { t0 } = this.derivative;
    if (t0.value) {
      return this.investTargetDisabled || !this.isAgree || !this.isWhitelistUsers;
    } else {
      return this.investTargetDisabled || this.derivativeDisabled;
    }
  }

  created() {
    this.investTarget = this.$t(
      "open_account.survey.page_one.invest_tagert_list"
    );
	this.getWhiteList();

    // this.derivative = this.$t("open_account.survey.page_one.derivative_list");
  }


  getWhiteList(){
  	  (this as any).$apis.getWhiteList().then(res =>{
  		  
        if(res.white_open === 1){
          if(res.white_manager === 0){
            this.isWhitelistUsers = false
          }else{
            this.isWhitelistUsers = true
          }
        }else{
          this.isWhitelistUsers = true
        }

  	  })
  }


  toggleCheckboxInput(item, option) {
    if (option.inputValue !== undefined) {
      const checked = item.value.includes(option.value);
      option.isChecked = checked;
      if (!checked) {
        option.inputValue = "";
      }
    }
  }

  handleDerivativeChange(val) {
    if (val) {
      if(!this.isWhitelistUsers){
        Toast(this.$t("open_account.survey.page_one.whitelist_users_tips"))
      }
      this.derivative.t0.children = {};
      this.isAgree = false;
    } else {
      this.derivative.t0.children = { t0: [], t1: [], t2: "" };
    }
  }

  handleChangeParentValue() {
    const derivative = this.derivative[0];
    derivative.options.forEach(option => {
      const children = option.children;
      if (children) {
        children.forEach(child => {
          (child as any).value = child.type == "checkbox" ? [] : "";
        });
      }
    });
  }

  handleNextStep() {
    if (!this.allowOpenAccount) {
      // return Toast(this.$t("open_account.survey.page_two.fail_toast_text"));
      return Dialog.confirm({
        ["message" as any]: this.$t(
          "open_account.survey.page_two.not_allow_open_account_dialog.content"
        ),
        ["cancelButtonText" as any]: this.$t(
          "open_account.survey.page_two.not_allow_open_account_dialog.cancelButtonText"
        ),
        ["confirmButtonText" as any]: this.$t("common.ok")
      })
        .then(() => {
          // on confirm
        })
        .catch(() => {
          // on cancel
          if (browser.isIdcApp) {
            this.$router.push({ name: "AccountIndex" });
            return;
          }
          if (browser.isApp) {
            jumpLink("go_home");
          } else {
            this.$router.push("/");
          }
        });
    }
    
    this.saveExamineList({
      investTarget: this.investTarget,
      derivative: this.derivative
    });
    this.$router.push("/survey/page-two");
  }
}
